import React, { useEffect } from 'react';
import { Grid, ButtonGroup, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setlayoutLiveTracking } from '../../features/layout/layoutSlice';


const DeviceViewFooter = ({ deviceData, deviceModel }) => {

    const dispatch = useDispatch();
    useEffect(() => {
        const liveTrackingLayoutPayload = {
            sidebarWidthratio: 0.25,
            minFooter: 80,
        };
        dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));
    }, [dispatch]);

    return (
        <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
            alignContent="center"
            wrap='wrap'
            spacing={1}
            style={{
                marginLeft: '0px',
                marginBottom: '10px',
                width: '90vw',
            }}
        >
            <Grid item key="model">
                <ButtonGroup>
                    <Button variant="contained" style={{
                        color: 'White',
                        backgroundColor: 'DodgerBlue'
                    }} size="small">
                        Model
                    </Button>
                    <Button variant="outlined" style={{
                        color: 'blueGray',
                    }} size="small"><span><b>{`${deviceModel}`}</b></span>

                    </Button>
                </ButtonGroup>
            </Grid>
            {
                deviceData && Object.keys(deviceData).map(name =>

                    <Grid item key={name}>
                        <ButtonGroup>
                            <Button variant="contained" style={{
                                color: 'White',
                                backgroundColor: 'DodgerBlue'
                            }} size="small">
                                {`${name}`}
                            </Button>
                            <Button variant="outlined" style={{
                                color: 'blueGray',
                            }} size="small"><span><b>{`${deviceData[name]}`}</b></span>

                            </Button>
                        </ButtonGroup>

                    </Grid>
                )
            }





        </Grid>
    );
}

export default React.memo(DeviceViewFooter);